import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getMatchesApi, getMatchesSortApi
} from "../../API/API";


function* getMatchesSaga(params) {
  
    try {
      const response = yield call(() => getMatchesApi(params));
      yield put({
        type: types.GET_MATCH_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: types.GET_MATCH_FAILURE, error });
    }
  }

  function* getMatchesSortSaga(params) { 
    try {
      const response = yield call(() => getMatchesSortApi(params));
      yield put({
        type: types.GET_MATCH_SORT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      yield put({ type: types.GET_MATCH_SORT_FAILURE, error });
    }
  }
  
  export function* watchGetMatchesSaga() {
    yield takeEvery(types.GET_MATCH_REQUESTED, getMatchesSaga);
  }

  export function* watchGetMatchesSortSaga() {
    yield takeEvery(types.GET_MATCH_SORT, getMatchesSortSaga);
  }

